// import { logError, LogErrorMetrics } from '@lib/tracking/felog'
// import { transformToObject } from '@lib/utils/error'

// import { IS_BROWSER } from "@constants/globals"

// const isTouch = (): boolean => {
//   return (
//     (typeof window !== 'undefined' && 'ontouchstart' in window) ||
//     // #ToDo improve typings to avoid any. Do we actually need to check for msMaxTouchPoints?
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//     !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || (navigator as any).msMaxTouchPoints))
//   )
// }

export const isTouchDevice = (): boolean => {
  try {
    // if (IS_BROWSER) {
    //   return isTouch()
    // }
  } catch (error) {
    console.log(error)
    // void logError('Touch device detection failed', LogErrorMetrics.TouchDeviceDetectionFailed, {
    //   error: transformToObject(error as Error),
    // })
  }

  return false
}
